<template>
  <div class="calculadora calculadora-superficie">
    <div class="row">

        <div class="col-md-4 mb-4">
          <div class="mb-4">
            <h3 v-html="strings.instructions.maintitle"></h3>
            <div class="sc-instrucoes" v-html="strings.instructions.desc"></div>
          </div>
          <div class="mb-4">
            <div class="sc-titulo">{{ strings.instructions.title }}</div>
            <div class="sc-instrucoes" v-html="strings.instructions.content"></div>
          </div>
        </div>

        <form @submit.prevent="calculate()" class="col-md-4">
            <h3 class="sc-titulo">{{strings.form.title}}</h3>
            <div class="form-group">
                <input @input="showResults = false" id="fld-sc-peso" class="form-control" v-model="peso" type="number" min="1" max="500" step="1" :placeholder="strings.form.fields.weight.placeholder" />
                <label for="fld-sc-peso">{{strings.form.fields.weight.title}}</label>
            </div>
            <div class="form-group">
                <input @input="showResults = false" id="fld-sc-altura" class="form-control" v-model="altura" type="number" min="1" max="250" step="1" :placeholder="strings.form.fields.height.placeholder" />
                <label for="fld-sc-altura">{{strings.form.fields.height.title}}</label>
            </div>
            <div class="form-group">
                <button type="submit" class="btn btn-primary">{{strings.form.calculate}}</button>
            </div>
        </form>
        <div class="col-md-4">
            <div v-if="showResults">
                <div>
                    <div class="sc-titulo">{{strings.result.title}}</div>

                    <div class="sc-resultado">
                        <strong>{{superficie.toFixed(2)}}</strong> <span>{{strings.result.description}}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
    export default {

        props: {
            strings: Object
        },

        data: () => { return {
            peso: '',
            altura: '',
            showResults: false,
        }},

        computed: {
            superficie: function() {
                return Math.sqrt((this.altura * this.peso) / 3600);
            },
        },

        methods: {
            calculate: function() {
                this.showResults = true;
            }
        }
    }
</script>
